import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestError } from '@fora-monorepo/employer-my-pages-common/types';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { getUnderMaintenance } from './errorThunks';
import { ErrorState } from './types/index';

export const initialErrorState: ErrorState = {
  underMaintenance: false,
  loadingUnderMaintenance: ThunkRequestStatus.Pending,
};

const errorSlice = createSlice({
  name: 'error',
  initialState: initialErrorState,
  reducers: {
    setThunkError(state, action: PayloadAction<RequestError>) {
      state.thunkError = {
        code: action.payload.code,
        message: action.payload.message,
      };
    },
    setUnderMaintenance(state, action: PayloadAction<boolean>) {
      state.underMaintenance = action.payload;
    },
  },
  extraReducers: builder => {
    // Get under maintenance
    // setUnderMaintenanceInterceptor will cath 503 status, ThunkRequestStatus is still needed to prevent forwarding to ks-login
    builder.addCase(getUnderMaintenance.fulfilled, (state, action) => {
      state.loadingUnderMaintenance = ThunkRequestStatus.Fulfilled;
    });
    builder.addCase(getUnderMaintenance.pending, state => {
      state.loadingUnderMaintenance = ThunkRequestStatus.Pending;
    });
    builder.addCase(getUnderMaintenance.rejected, state => {
      state.loadingUnderMaintenance = ThunkRequestStatus.Rejected;
    });
  },
});

export const { setThunkError, setUnderMaintenance } = errorSlice.actions;

export const errorReducer = errorSlice.reducer;
